import ApolloErrorBoundary from '@components/ApolloErrorBoundary';
import { type FC, Suspense } from 'react';
import { GateMovementData, useMovementData } from '../hooks/useMovementData';

interface Props {
  movementId: string;
  render: FC<GateMovementData>;
  fallback: FC;
}

export const MovementDataRenderer: FC<Props> = (props) => {
  const Fallback = props.fallback;

  return (
    <ApolloErrorBoundary variant="section-alert">
      <Suspense fallback={<Fallback />}>
        <SuspenseComponent {...props} />
      </Suspense>
    </ApolloErrorBoundary>
  );
};

const SuspenseComponent: FC<Props> = ({ movementId, render: Render }) => {
  const data = useMovementData(movementId);
  return <Render {...data} />;
};
